import PrescriptionPhoto from "./PrescriptionPhoto/PrescriptionPhoto";
import styles from "./PrescriptionPhotos.module.scss";
import { PrescriptionResponse } from "../../../types/shared";

type Props = {
  prescriptionsLinks: PrescriptionResponse[];
  permitForStore?: string | null;
};

const PrescriptionPhotos = ({ prescriptionsLinks, permitForStore }: Props) => {
  if (!prescriptionsLinks?.length && !permitForStore) {
    return null;
  }

  return (
    <div className={styles.PrescriptionPhotos}>
      {prescriptionsLinks?.map((link: PrescriptionResponse, index: number) => (
        <PrescriptionPhoto key={link.id || index} prescriptionLink={link} />
      ))}
      {permitForStore && (
        <a
          className={styles.permitWrap}
          target="_blank"
          rel="noreferrer"
          href={permitForStore}
        >
          Punomoćje
        </a>
      )}
    </div>
  );
};

export default PrescriptionPhotos;
